module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Cooking/Fork-3c10d79ddf451ca57466420999a64c3f82476313f7efbe0d9d5891c13d70a71e.svg";